import React from "react";
import { Button, Grid, Header } from "semantic-ui-react";
import userManager from '../userManager';

export default class UserExpired extends React.Component {

    render() {
        return (
            <Grid centered={true}>
                <Grid.Row />
                <Grid.Row>
                    <Header as="h1" textAlign="center">
                        La sessione è scaduta
                        <Header.Subheader>
                            Per utilizzare i servizi è necessario effettuare il login dalla finestra principale
                        </Header.Subheader>
                    </Header>
                </Grid.Row>
                <Grid.Row />
                <Grid.Row>
                    <Button onClick={this.logoutClick}>Logout e ritorna alla finestra principale</Button>
                </Grid.Row>
            </Grid>
        );
    }

    logoutClick = () => {
        userManager.signoutRedirect();
    }
}